module.exports = __webpack_public_path__ + "media/LandingPageAssets/whiteLogo-ac3e8c15.svg";